import React from "react";
import { AudioPlayer } from "react-audio-play";
import { CellProps, Table } from "rsuite";
const { Cell } = Table;

// Define the interface for AudioCell props
interface AudioCellProps extends CellProps<any>{
    dataKey: string; // The key to access the image URL in rowData
}

// Helper function to safely access nested object properties
const getNestedValue = (obj: any, path: string) => {
  return path.split('.').reduce((value, key) => value?.[key], obj);
};

// Create the AudioCell component
const AudioCell: React.FC<AudioCellProps> = ({ dataKey, ...props }) => {
  const audioUrl = getNestedValue(props.rowData, dataKey); // Use the helper function

  return (
      <Cell {...props} style={{padding:2}}>
      {/* {props.rowData[dataKey] ? ( */}
      {audioUrl ? (
        <div
          style={{
            height: '100%', // Match row height
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <AudioPlayer width='100%' preload="none" src={audioUrl} style={{
            height: '100%', // Fill the height of the div
            boxShadow: 'none',
            transform: 'scale(0.7)',
            borderRadius: 10
          }}/>
        </div>
      ) : null}
    </Cell>
  );
};

export default AudioCell;